import { Star } from "lucide-react";

const testimonials = [
  {
    quote: "We replaced three tools — email marketing, dialer, and CRM — with FreeCRM. Our team now runs campaigns across email, SMS, and calls from one place.",
    name: "Maya Chen",
    role: "VP of Sales, Velocity",
  },
  {
    quote: "Multi-channel sequences changed everything. Mixing email, SMS, and a call in one cadence doubled our reply rate without adding headcount.",
    name: "Daniel Okafor",
    role: "Sales Director, Apex Solutions",
  },
  {
    quote: "We switched from HubSpot to FreeCRM and finally got email marketing, voice, and SMS in one platform — with zero integration costs.",
    name: "Priya Raman",
    role: "COO, Brightline",
  },
];

const Testimonials = () => {
  return (
    <section id="testimonials" className="bg-muted/40 py-24">
      <div className="container">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-semibold uppercase tracking-widest text-primary">Customers</span>
          <h2 className="mt-3 font-display text-4xl font-bold text-secondary md:text-5xl">
            Trusted by multi-channel sales teams
          </h2>
        </div>
        <div className="mt-14 grid gap-6 md:grid-cols-3">
          {testimonials.map((t) => (
            <figure key={t.name} className="flex flex-col rounded-2xl border border-border bg-card p-7 shadow-card">
              <div className="flex gap-0.5 text-primary">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star key={i} className="h-4 w-4 fill-current" />
                ))}
              </div>
              <blockquote className="mt-4 flex-1 text-lg leading-relaxed text-secondary">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-6 border-t border-border pt-4">
                <div className="font-semibold text-secondary">{t.name}</div>
                <div className="text-sm text-muted-foreground">{t.role}</div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
